<template>
    <div>
        <div style="margin-bottom: 30px;">
            正在对 {{namekey}} 位置上传视频

        </div>
        <div style="text-align: center;" v-if="kuinfo.parent!=0">
            <el-upload class="upload-demo" drag action="#" multiple :http-request="cos_upload" :before-upload="cos_upload_fast"
                :on-preview="cos_file_list_fc" :on-progress="cos_uploading"
                :file-list="cos_videoFileList" accept=".mp4">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传mp4文件，且不超过5MB的视频</div>
            </el-upload>
        </div>
        <div style="text-align: center;" v-else>
            <el-upload class="upload-demo" drag action="#" multiple :http-request="upload" :before-upload="upload_fast"
                :on-preview="file_list_fc" :on-progress="uploading"
                :file-list="videoFileList" accept=".mp4">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传mp4文件，且不超过100MB的视频</div>
            </el-upload>
        </div>

        <!-- <el-button @click="wc">完成</el-button> -->
    </div>
</template>

<script>
import { indexOf } from 'shelljs/commands';

// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
const COS = require('cos-js-sdk-v5');

export default {
    name: '',
    components: {

    },
    props: ["kuinfo", 'namekey'],
    // 定义属性
    data() {
        return {
            videoFileList:[],
            cos_videoFileList:[]
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        upload_fast(file) {
            const isJPG = file.type === 'video/mp4';
            const isLt2M = file.size / 1024 / 1024 < 100;

            if (!isJPG) {
                this.$message.error('上传视频文件只能是 mp4 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传视频大小不能超过 100MB!');
            }
            return isJPG && isLt2M;

        },
        upload(param) {
            // console.log(e)
            // this.$msg.success('正在上传中..上传页面可关闭')
            param.status = 'uploading';    //文件上传状态
            param.percentage = 0;    //文件上传进度，这里设为0
            param.name = param.file.name    //文件名
            this.videoFileList.push(param)    //添加到选择文件列表

            var data = this.kuinfo
            
            data['filename'] = param.file.name
            this.$ajax.post('/qhy/spk/upload_token', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                // console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    let fdata = new window.FormData();
                    fdata.append('file', param.file)
                    fdata.append('key', jg.data.key)
                    fdata.append('kuname', data.name)
                    // this.$ajax_upload.post(jg.data.url, fdata, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    //     // console.log(res.data)
                    //     if (res.data.indexOf('处理插入成功') !== false) {
                    //         this.$msg.success(e.file.name + '上传成功')
                    //     }
                    // })
                    this.$ajax_upload.post(jg.data.url, fdata, {
                        onUploadProgress: function (progressEvent) { // 处理上传进度事件
                            let percent = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);   //计算出上传的进度，去整数位
                            param.percentage = percent;  //动态设置param的percentage
                            // console.info(percent)
                        }
                    }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(response => {
                        //请求成功
                        // console.log(response.data);
                        if (response.data.indexOf('处理插入成功') !== false) {
                            param.status = 'success';  //上传成功后将status属性改成success
                            this.$msg.success(param.file.name + '上传成功')
                        } else {
                            param.status = 'failed';
                            param.message = '上传失败';
                        }
                        // this.video_num--
                        // if (this.video_num == 0) {
                        //     this.video_num = 0
                        //     this.$alert('视频任务上传提交成功', '视频上传', {
                        //         confirmButtonText: '确定',
                        //         callback: action => {
                        //             this.videoFileList = []
                        //             this.$refs.Balance.get_user()
                        //         }
                        //     });

                        // }



                    }).catch(function (error) {
                        // 请求失败处理
                        console.log(error);
                        param.status = 'failed';
                        param.message = '上传失败';
                    });

                } else {
                    this.$msg.error('获取失败')
                }

            })
            if (this.kuinfo.parent != 0) {
                //片段上传
                let that = this;
                let t = 'api返回的数据';
                let cosf = new COS({
                    SecretId: t.tmp_secretId,
                    SecretKey: t.tmp_secretKey,
                    SecurityToken: t.session_token
                });
            } else {
                //诊断上传分割
            }


        },
        file_list_fc(file) {
            console.log(file)
        },

        //cos
        cos_upload_fast(file) {
            const isJPG = file.type === 'video/mp4';
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传视频文件只能是 mp4 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传视频大小不能超过 10mb!');
            }
            return isJPG && isLt2M;

        },
        cos_upload(param) {
            var that= this

            param.status = 'uploading';    //文件上传状态
            param.percentage = 0;    //文件上传进度，这里设为0
            param.name = param.file.name    //文件名
            this.cos_videoFileList.push(param)

            var dzkey='spk/'+this.kuinfo['uid']+'/'+this.kuinfo['parent']+'/'+this.kuinfo['wz']+'/'+param['file']['name']
            var data={
                filename:param.file.name,
                ku:this.kuinfo,
                dzkey:dzkey
            }
            this.$ajax.post('/qhy/spk/cos_sts', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                
                if(res.status==200){
                    let cosf = new COS({
                        SecretId: res.data.data.Credentials.TmpSecretId,
                        SecretKey: res.data.data.Credentials.TmpSecretKey,
                        SecurityToken: res.data.data.Credentials.Token
                    });
                    cosf.putObject({
                        Bucket: 'spk-1301238423', /* 填入您自己的存储桶，必须字段 */
                        Region: 'ap-guangzhou',  /* 存储桶所在地域，例如ap-beijing，必须字段 */
                        Key: dzkey,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
                        Body: param.file, /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */
                        onProgress: function(progressData) {
                            console.log(JSON.stringify(progressData));
                            let percent = progressData.percent*100;   //计算出上传的进度，去整数位
                            param.percentage = percent;
                        }
                    }, function(err, data) {
                        console.log(err || data);
                        if(data.statusCode==200){
                            param.status = 'success';
                        }
                        
                    });

                }
                
                
            })
        },
        cos_file_list_fc(file) {
            console.log(file)
        },
        cos_uploading(e) {
            console.log(e)
        },
        wc() {
            this.$parent.$parent.upload_video_wc()
        },
        handlePreview(e) {
            console.log(e)
        },
        uploading(e) {
            console.log(e)
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/User/Ku_upload.vue


// WEBPACK FOOTER //
// src/components/User/Ku_upload.vue